/** Picklist values per descriptor field (generated from manifests + vtlib; see reference/picklists.json). */
export const picklists = {
    "ai_system": {
        "area_allegato_iii": [
            "biometrics",
            "critical_infrastructure",
            "education",
            "employment",
            "essential_services",
            "law_enforcement",
            "migration",
            "justice_democracy"
        ],
        "categoria_rischio": [
            "Inaccettabile",
            "Alto",
            "Limitato",
            "Minimo"
        ],
        "ruolo_ai_act": [
            "deployer",
            "provider",
            "importer",
            "distributor"
        ],
        "stato_approvazione": [
            "In valutazione",
            "Approvato",
            "Respinto",
            "Dismesso"
        ]
    },
    "cmp_acceptance": {
        "acceptance_status": [
            "Email Sent",
            "Email Delivered",
            "Final Acceptance",
            "Rifiutato"
        ],
        "accmethod": [
            "Firma Digital",
            " Click-through",
            " Email",
            "Altro"
        ],
        "contact_type": [
            "training",
            "--None--",
            "Customer",
            "Employee",
            "training_dpi"
        ]
    },
    "cmp_aml_verification": {
        "fattori_rischio": [
            "Cliente PEP (Persona Politicamente Esposta)",
            "Cliente PEP",
            "Paese ad alto rischio",
            "Assenza attivita economica apparente",
            "Operazioni in contanti elevate",
            "Struttura societaria complessa",
            "Settore merceologico a rischio",
            "Assenza di attività economica apparente",
            "Cliente non residente"
        ],
        "livello_rischio": [
            "Basso",
            "Medio",
            "Alto",
            "Molto Alto"
        ],
        "sos_effettuata": [
            "No",
            "Si"
        ],
        "stato_conservazione": [
            "In Corso",
            "Archiviato",
            "Da Distruggere"
        ],
        "tipo_verifica": [
            "Semplificata",
            "Ordinaria",
            "Rafforzata"
        ]
    },
    "cmp_asset": {
        "access_level": [
            "Manager",
            "Limitato",
            "Tutti gli Utenti",
            "Amministrazione",
            "Tecnico",
            "Portineria",
            "Risorse Umane"
        ],
        "asset_status": [
            "Attivo",
            "Da Installare"
        ],
        "asset_type": [
            "Network",
            "Server",
            "SaaS",
            "IoT",
            "Software",
            "Data",
            "Physical"
        ],
        "backup_freq": [
            "Settimanale",
            "Giornaliera",
            "Non Configurato",
            "In Tempo Reale",
            "Mensile",
            "Trimestrale",
            "Annuale"
        ],
        "category": [
            "System",
            "BPM",
            "PC Desktop",
            "Hardware",
            "Mobile Device",
            "Sicurezza",
            "User Interface",
            "IAM",
            "Tablet",
            "Performance",
            "Studio",
            "Accessorio",
            "Module Functionality",
            "Email",
            "Smartphone",
            "Other",
            "Login",
            "Software",
            "Integration",
            "Sistema",
            "Application",
            "Infrastruttura",
            "Telecamera",
            "Database",
            "Servizio Esterno"
        ],
        "cloudservice": [
            "Amazon AWS",
            "Locale",
            "Cloud",
            "Ibrido",
            "Microsoft Azure",
            "Non applicabile"
        ],
        "criticality": [
            "critical",
            "high",
            "medium",
            "low"
        ],
        "elaborative_system": [
            "Windows/Office",
            "iOS/iPadOS",
            "Bluetooth HID",
            "Bluetooth input",
            "Protezione fisica",
            "Android",
            "SISTEMI SOLUZIONI INFORMATICHE SPA",
            "Microsoft Exchange/IMAP",
            "SISTEMI OPEN SRL",
            "TCP/IP",
            "Sistema NVR",
            "MySQL/SQL Server",
            "Exchange/IMAP Server",
            "B&C (CONTI OMAR)",
            "Sistemi Due Milano",
            "Synthesis Solutions",
            "CLS D GN",
            "Centro Medico Italiano"
        ],
        "framework_tags": [
            "GDPR",
            "NIS2",
            "ISO27001",
            "DORA"
        ],
        "license_type": [
            "Abbonamento",
            "Open Source",
            "Perpetua",
            "Volume License"
        ],
        "operating_system": [
            "Windows 10",
            "Windows 11",
            "iPadOS",
            "Non Applicabile",
            "Android",
            "Linux CentOS",
            "Windows Server",
            "FreeBSD",
            "Linux Ubuntu",
            "Linux RHEL"
        ],
        "risk_evaluation": [
            "Basso",
            "Medio",
            "Alto",
            "Molto Alto"
        ]
    },
    "cmp_audit": {
        "audit_status": [
            "Planned",
            "In_Progress",
            "Completed",
            "Failed"
        ],
        "audittype": [
            "Privacy Audit",
            "DVR",
            "DVRI",
            "Security Audit",
            "Compliance GDPR",
            "Process Audit",
            "Compliance NIS2",
            "Compliance Audit",
            "Interno",
            "Other"
        ],
        "framework_tags": [
            "GDPR",
            "WorkplaceSafety",
            "NIS2",
            "ISO27001",
            "DORA"
        ]
    },
    "cmp_content": {
        "page": [
            "Privacy Policy",
            "Cookie Policy",
            "Informativa",
            "Contratto",
            "Consenso",
            "Nessuna"
        ],
        "position": [
            "Bozza",
            "In revisione",
            "Attivo",
            "Scaduto",
            "Revocato"
        ]
    },
    "cmp_data_breach": {
        "dbranalysisactions": [
            "Avvio analisi forensi",
            " Raccolta log di sistema",
            " Mappatura sistemi compromessi",
            " Identificazione vettore attacco",
            " Verifica estensione violazione",
            " Analisi timeline evento",
            " Review accessi anomali",
            " Verifica integrità dati",
            " Mappatura dati esfiltrati",
            " Documentazione evidenze"
        ],
        "dbrcategory": [
            "Violazione di confidenzialità",
            "Violazione di integrità",
            "Violazione di disponibilità",
            "Accesso non autorizzato",
            "Modifica non autorizzata",
            "Perdita di dati",
            "Distruzione di dati",
            "Altro"
        ],
        "dbrcorrectiveactions": [
            "Implementazione controlli aggiuntivi",
            " Rafforzamento misure sicurezza",
            " Aggiornamento policy accessi",
            " Revisione procedure backup",
            " Implementazione encryption",
            " Installazione sistemi IDS/IPS",
            " Segmentazione rete",
            " Hardening sistemi",
            " Implementazione WAF",
            " Attivazione MFA"
        ],
        "dbrdatatype": [
            "Dati anagrafici",
            "Dati finanziari",
            "Dati sanitari",
            "Dati biometrici",
            "Dati giudiziari",
            "Credenziali accesso",
            "Altri dati particolari"
        ],
        "dbrimmediateactions": [
            "Isolamento sistemi compromessi",
            " Blocco accessi non autorizzati",
            " Disattivazione temporanea servizi coinvolti",
            " Ripristino backup sistemi",
            " Modifica credenziali di accesso",
            " Attivazione modalità manutenzione",
            " Redirezione traffico di rete",
            " Applicazione patch di sicurezza",
            " Esecuzione scansione malware",
            " Attivazione monitoraggio avanzato"
        ],
        "dbrmodality": [
            "monitoraggio interno",
            " segnalazione utente",
            " segnalazione esterna",
            " altro"
        ],
        "dbrnotifyactions": [
            "Attivazione protocollo comunicazione interna",
            " Notifica preliminare DPO",
            " Comunicazione management",
            " Preparazione notifica Garante",
            " Redazione comunicazione interessati",
            " Attivazione call center dedicato",
            " Predisposizione FAQ",
            " Aggiornamento sito web",
            " Preparazione comunicato stampa",
            " Notifica forze dell'ordine"
        ],
        "dbrpriority": [
            "bassa",
            " media",
            " alta",
            " critica"
        ],
        "dbrstatus": [
            "rilevato",
            " in analisi",
            " notificato",
            " risolto",
            " chiuso"
        ],
        "framework_tags": [
            "GDPR",
            "NIS2",
            "ISO27001"
        ],
        "incident_type": [
            "gdpr_breach",
            "nis2_incident",
            "both"
        ],
        "risk_to_individuals": [
            "unlikely",
            "risk",
            "high"
        ]
    },
    "cmp_measure": {
        "csf_function": [
            "Govern",
            "Identify",
            "Protect",
            "Detect",
            "Respond",
            "Recover"
        ],
        "framework_tags": [
            "GDPR",
            "NIS2",
            "ISO27001",
            "DORA"
        ],
        "implementation_status": [
            "TBD",
            "In_Progress",
            "Implemented"
        ],
        "task_layer": [
            "BASELINE",
            "ENHANCEMENT"
        ]
    },
    "cmp_policy": {
        "framework_tags": [
            "GDPR",
            "NIS2",
            "ISO27001",
            "DORA"
        ],
        "policy_type": [
            "Generic",
            "dpa",
            "GDPR privacy policy",
            "security_annex",
            "GDPR Notice",
            "Whistleblowing",
            "ISO 9001"
        ],
        "policystatus": [
            "Draft",
            "In approvazione",
            "Deliberata",
            "In uso",
            "Archiviata"
        ]
    },
    "cmp_processing_activity": {
        "legal_basis": [
            "Consent",
            "Obbligo legale, contratto",
            "Esecuzione contratto",
            "Legittimo interesse, consenso",
            "Consenso, legittimo interesse",
            "Obbligo legale",
            "Obbligo legale; Esecuzione di un contratto",
            "Consenso dell'interessato",
            "Obblighi contrattuali; Obblighi derivanti da legge",
            "Esecuzione di un contratto",
            "Obbligo fiscale",
            "Consenso",
            "Adempimento di obblighi contrattuali",
            "Adempimento di obblighi contrattuali; Consenso per raccolta dati particolari",
            "Interesse legittimo",
            "Contractual necessity",
            "Legal obligation",
            "Vital interests",
            "Public interest",
            "Legitimate interests"
        ],
        "processing_methods": [
            "Automated",
            "Manual",
            "Partially automated",
            "Batch processing",
            "Real-time processing",
            "Encrypted processing",
            "Anonymized",
            "Pseudonymized"
        ],
        "processing_risk_level": [
            "Low",
            "Medium",
            "High",
            "Very High",
            "Not Assessed"
        ]
    },
    "cmp_third_party": {
        "activity_type": [
            "Real Estate & Property Management",
            "Real Estate",
            "Manufacturing",
            "Manufacturing & Industrial",
            "Professional Services",
            "Professional Services & Consulting",
            "Commercial",
            "Commercial & Retail",
            "Transportation",
            "Transportation & Logistics"
        ],
        "assessment_status": [
            "assessed",
            "pending",
            "failed",
            "not_required"
        ],
        "criticality": [
            "critical",
            "important",
            "standard"
        ],
        "framework_tags": [
            "GDPR",
            "NIS2",
            "ISO27001",
            "DORA"
        ],
        "transfer_mechanism": [
            "adequacy_decision",
            "scc",
            "bcr",
            "art49_derogation"
        ]
    },
    "cmp_threat": {
        "framework_tags": [
            "GDPR",
            "NIS2",
            "ISO27001",
            "DORA"
        ],
        "residual_impact": [
            "Trascurabile",
            "Minore",
            "Moderato",
            "Significativo",
            "Catastrofico"
        ],
        "residual_probability": [
            "Raro",
            "Improbabile",
            "Possibile",
            "Probabile",
            "Quasi certo"
        ],
        "treatment": [
            "accept",
            "mitigate",
            "transfer",
            "avoid"
        ],
        "type_of_threats": [
            "Normal",
            "Micro-organization",
            "Pure tech",
            "Pure analog"
        ]
    },
    "cmp_worker_group": {
        "activity_type": [
            "Real Estate & Property Management",
            "Real Estate",
            "Manufacturing",
            "Manufacturing & Industrial",
            "Professional Services",
            "Professional Services & Consulting",
            "Commercial",
            "Commercial & Retail",
            "Transportation",
            "Transportation & Logistics"
        ],
        "dpi_required": [
            "Guanti",
            "Occhiali/Visiera",
            "Casco/Elmetto",
            "Scarpe antinfortunistiche",
            "Imbracatura di sicurezza",
            "Mascherina/Respiratore",
            "Cuffie/Tappi antirumore",
            "Tuta protettiva",
            "Gilet alta visibilità",
            "Nessuno"
        ],
        "framework_tags": [
            "GDPR",
            "WorkplaceSafety",
            "NIS2",
            "ISO27001",
            "DORA"
        ],
        "frequenza_visita": [
            "Annuale",
            "Biennale",
            "Quinquennale",
            "A richiesta"
        ],
        "multi_complexity": [
            "small",
            "medium",
            "large"
        ],
        "orario_lavoro": [
            "Giornaliero",
            "Notturno",
            "A turni",
            "Part-time",
            "Irregolare"
        ]
    }
};
